import { useState } from "react";
import { useLocation } from "react-router";

import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";
import { CampaignOrgUnitsCreateForm } from "../components/forms/CampaignOrgUnitsCreateForm";

export const CampaignOrgUnitsCreateFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const location = useLocation();
    const { terminalIds, siteIds } = location.state || {};

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.campaignsCreateFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.CAMPAIGNS}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <CampaignOrgUnitsCreateForm runSubmit={runSubmit} terminals1={terminalIds} sites1={siteIds} />
            </FPageContent>
        </FPage>
    );
};
